import React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { FiClock, FiGift, FiHeart, FiShoppingBag } from "react-icons/fi";
import { IconType } from "react-icons";

interface CategoryItem {
  id: number;
  label: string;
  icon: IconType;
  chartId: string;
}

// Hard-coded array (no isActive)
const categories: CategoryItem[] = [
  {
    id: 1,
    label: "Best",
    icon: FiHeart,
    chartId: "clt8w003c1e4k07k0tmgedthh",
  },
  {
    id: 2,
    label: "Same-Day",
    icon: FiClock,
    chartId: "clt8w14741dxv07jzaw0hl0hq",
  },
  {
    id: 3,
    label: "Birthday",
    icon: FiGift,
    chartId: "clt8w019b1h9y08ld2bi6anhk",
  },
  {
    id: 4,
    label: "Sympathy",
    icon: FiHeart,
    chartId: "clt8w18w11h3y07lcqq2sa25w",
  },
  {
    id: 5,
    label: "Gift Baskets",
    icon: FiShoppingBag,
    chartId: "clt8w0mr61gvs07lcyj22y0vz",
  },
  {
    id: 6,
    label: "Plants",
    icon: FiClock,
    chartId: "clt8w108h1hlz08ld8oblvozw",
  },
  {
    id: 7,
    label: "Balloons",
    icon: FiClock,
    chartId: "clt5o5uvd260706k52j6xoos4",
  },
];

const CategoryNav: React.FC = () => {
  const router = useRouter();
  const { domain, slug } = router.query;

  return (
    <nav className="w-full overflow-x-auto md:-mb-5">
      <ul className="flex whitespace-nowrap items-center gap-2">
        {categories.map(({ id, label, icon: Icon, chartId }) => {
          const isActive = router.query['chartId'] === chartId || (!router.query['chartId'] && chartId === "clt8w003c1e4k07k0tmgedthh");

          return (
            <li key={id}>
              <Link 
                    href={{
                        pathname: router.pathname,
                        query: {
                          domain,
                          slug,
                          chartId,
                        },
                      }}
                      className={`
                        no-underline !no-underline visited:no-underline
                        !text-black visited:text-black
                        flex items-center gap-1 
                        py-1 px-3 
                        rounded-full border 
                        transition-colors
                        whitespace-nowrap
                        ${
                          isActive
                            ? "bg-white !text-rose-500 border-gray-300 shadow-sm"
                            : "bg-transparent border-gray-200 hover:bg-gray-100 text-gray-700 hover:!text-rose-500"
                        }
                      `}
                >
                  <Icon className="text-sm" />
                  <span className="text-sm font-normal">
                    {label}
                  </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default CategoryNav;
